/*
/luagate の日付の書き方の決まり (全画面でこの関数だけを使う)
  今年 (日本時間) の日付は「10/7」。年は出さない
  今年でない日付は「2026 年 10 月 7 日」。年と月と日の間に半角の空きを入れる
  札の下の行 (難易度の棒や数と並ぶ所) は formatLgDateWords で「10 月 7 日」と書く。「10/7」は数の割合に見えるため
  取れない値は空の字にする
日本時間で数えるので、SSR (UTC) とブラウザで同じ字になる
*/

const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

function jstParts(ms: number): { year: number; month: number; day: number } {
  const d = new Date(ms + JST_OFFSET_MS);
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
}

/** ISO の日時か YYYY-MM-DD を受け取る。YYYY-MM-DD は日本の暦の日付としてそのまま読む */
export function formatLgDate(value: string | Date | null | undefined, nowMs: number = Date.now()): string {
  if (!value) return "";
  let target: { year: number; month: number; day: number };
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    target = { year: Number(value.slice(0, 4)), month: Number(value.slice(5, 7)), day: Number(value.slice(8, 10)) };
  } else {
    const ms = (value instanceof Date ? value : new Date(value)).getTime();
    if (Number.isNaN(ms)) return "";
    target = jstParts(ms);
  }
  if (target.year === jstParts(nowMs).year) return `${target.month}/${target.day}`;
  return `${target.year} 年 ${target.month} 月 ${target.day} 日`;
}

/** 札の下の行で使う。今年なら「10 月 7 日」、今年でなければ formatLgDate と同じ「2026 年 10 月 7 日」 */
export function formatLgDateWords(value: string | Date | null | undefined, nowMs: number = Date.now()): string {
  const short = formatLgDate(value, nowMs);
  const m = /^(\d+)\/(\d+)$/.exec(short);
  return m ? `${m[1]} 月 ${m[2]} 日` : short;
}

/**
 * 年のある日付を、年から必ず書く。「2026年6月6日」。数と日本語の単位のあいだに空きを入れない。
 * 公開日や作成日のように、年が分からないと「いつの」が読めない値に使う (formatLgDate は今年の年を省く)
 */
export function formatLgDateFull(value: string | Date | null | undefined): string {
  if (!value) return "";
  let p: { year: number; month: number; day: number };
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    p = { year: Number(value.slice(0, 4)), month: Number(value.slice(5, 7)), day: Number(value.slice(8, 10)) };
  } else {
    const ms = (value instanceof Date ? value : new Date(value)).getTime();
    if (Number.isNaN(ms)) return "";
    p = jstParts(ms);
  }
  return `${p.year}年${p.month}月${p.day}日`;
}
